import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Moment } from "moment";

interface IProps {
  startDate?: string;
  trialPopup?: boolean;
}

const initialState: IProps = {
  startDate: undefined,
  trialPopup: false,
};

export const generalSettingsSlice = createSlice({
  name: "generalSettings",
  initialState,
  reducers: {
    setGeneralSettings: (state, action: PayloadAction<IProps>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetGeneralSettings: (state) => {
      return {
        startDate: undefined,
        trialPopup: false,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setGeneralSettings, resetGeneralSettings } = generalSettingsSlice.actions;
export default generalSettingsSlice.reducer;
